import { confirmationSequence, updateOrderedConfirmation } from "./confirmation-sequence";

export const ONBOARDING_CONSENT_VERSION = "2026-10-10-v1";
export const sensitiveInformation = [
  { key: "portrait", title: "人脸与人像信息处理", content: "人脸特征、活体核验信息及本人提供的人像素材", purpose: "身份核验、AI 建模与形象授权；网站不留存刷脸原始照片或视频" },
  { key: "identity", title: "身份核验信息处理", content: "姓名、身份证号码等身份信息", purpose: "实名认证与交易签约" },
  { key: "financial", title: "金融账户信息处理", content: "结算时由本人提供的银行账户或支付账户信息", purpose: "收益结算与打款" },
  { key: "agency", title: "机构信息提供", content: "通过机构签约时，由机构向平台提供的本人相关信息", purpose: "机构签约与授权管理；无机构请选择“不适用”" },
  { key: "preview", title: "素材公开展示", content: "本人选择用于公开展示的人像素材展示图", purpose: "供买方浏览选择" },
] as const;
export type ConsentKey = typeof sensitiveInformation[number]["key"];
export type ConsentChoices = Record<ConsentKey, "agree" | "disagree" | "not_applicable" | "">;
const consentKeys = sensitiveInformation.map(item => item.key);
export function acceptedConsentChoice(key: ConsentKey, value: unknown) {
  return value === "agree" || (key === "agency" && value === "not_applicable");
}
export function acceptedConsentChoices(value: unknown): value is ConsentChoices {
  if (!value || typeof value !== "object" || Array.isArray(value)) return false;
  const choices = value as Record<string, unknown>;
  return Object.keys(choices).length === consentKeys.length
    && confirmationSequence(consentKeys, key => acceptedConsentChoice(key, choices[key])).complete;
}

export function consentItemUnlocked(choices: ConsentChoices, index: number) {
  return confirmationSequence(consentKeys, key => acceptedConsentChoice(key, choices[key])).isUnlocked(index);
}
export function updateConsentChoice(choices: ConsentChoices, key: ConsentKey, agreed: boolean): ConsentChoices {
  return updateOrderedConfirmation(consentKeys, choices, key, agreed ? "agree" : "", "", acceptedConsentChoice);
}
